import React, { useState } from "react";
import { useRouter } from "next/router";
import Link from "@/utils/link";

import { useAuth } from "@/lib/auth";

import { isSignedIn } from "@/components/user/UserUtils";
import PurpleDoorLogoHorizontal from "@/components/Logo/PurpleDoorLogoHorizontal";
//import { useWindowSize } from "@/utils/hooks";
import CpHomeHeaderMenu from "./CpHomeHeaderMenu";
import { prospectHost } from "@/utils/config";

export const links = [
    { link: "/", label: "All" },
    { link: "/independent-living", label: "Independent" },
    { link: "/assisted-living", label: "Assisted" },
    { link: "/memory-care", label: "Memory" },
];

export const LinkItem = ({ link, label, disabled = false }) => {
    return (
        <div className="text-primary-50 font-bold hover:text-primary-300">
            <Link href={link} disabled={disabled}>
                <a>{label}</a>
            </Link>
        </div>
    );
};

const CpHomeHeader = ({ fixed }) => {
    const router = useRouter();
    const auth = useAuth();
    const token = auth && auth.user ? auth.user.token : "";

    return (
        <>
            <div
                className={`z-50 min-w-full bg-primary-500 text-primary-50 shadow ${
                    fixed ? "fixed" : "static"
                }`}
            >
                <nav className="h-12 sm:h-16 flex justify-between items-center">
                    <div className="flex items-center">
                        <Link href={prospectHost}>
                            <a className="-ml-10 sm:ml-2 scale-75 sm:scale-100">
                                <PurpleDoorLogoHorizontal inverse={true} />
                            </a>
                        </Link>
                    </div>

                    <div className="sm:flex sm:items-center sm:gap-8">
                        <div className="hidden sm:flex items-center gap-8">
                            <LinkItem link={prospectHost} label="For Residents" />
                        </div>

                        <div className="hidden sm:flex items-center gap-8">
                            <LinkItem
                                link="/community-portal/my-communities"
                                label="My Communities"
                                disabled={!isSignedIn(auth)}
                            />
                        </div>

                        <div className="hidden sm:flex items-center gap-8">
                            <LinkItem
                                link="/community-portal/#pricing-section"
                                label="Pricing"
                            />
                        </div>

                        <div className="-ml-12 sm:ml-0">
                            <CpHomeHeaderMenu />
                        </div>
                    </div>
                </nav>
            </div>
        </>
    );
};

export default CpHomeHeader;
